module.exports = __webpack_public_path__ + "images/patterns/dark/GrooveDiagonal.6651027327b53ab2a861.svg";